import { render, staticRenderFns } from "./trades.vue?vue&type=template&id=78590efe&"
import script from "./trades.vue?vue&type=script&lang=js&"
export * from "./trades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports